import Vue from 'vue'
import Router from 'vue-router'
import { routerMap } from './routes'

Vue.use(Router)

//解决vue项目路由出现message: "Navigating to current location (XXX) is not allowed"的问题
const routerPush: any = Router.prototype.push
Router.prototype.push = function push(location: any) {
  return routerPush.call(this, location).catch((error: any) => {
    console.log('routerPush', error)
  })
}

export default new Router({
  mode: 'history',
  routes: routerMap
})
